import gMenuItem from "@/components/g-menu/components/g-menu-item.vue";
import router from "@/router";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import EVENTS from "@/shared/events/events";
import AccountLoged from "@/shared/mixins/AccountLoged";
import { JWTService } from "@/shared/services/jwt";
import Tools from "@/shared/services/tools";
import { defineComponent } from "vue";
import gButton from "../g-button/g-button.vue";
import UsuarioController from "@/shared/controllers/usuario/usuarioController";


export default defineComponent({
  name: "g-menu",
  components: {
    "g-menu-item": gMenuItem,
    "g-button": gButton,
  },
  data() {
    return {
      TokenClaims: [],
      ClaimsArray: ["Usuário", "Cidades", "Grupos", "Transportadoras", "Comissões", "Log", "Parâmetros", "Liberação de Representante", "Usuários Logados", "Condições de Pagamento" ],
      EmpresaArray: [],
      tentouFechar: false,
      RepresentanteArray: this.$store.state.RepresentanteArray,
      empresaSelecionadaId: '',
      representanteSelecionadoId: '',
      grenciamento: false,
      TypeGerenciamento: false,
      unidadeRepresentanteMenu: false,
      menuVisivel: false,
      selectedNode: null,
      estaCarregando: false,
      popupsair: false,
      configuracoes: false,
      dadosUsuario: {},
      representanteSelecionadoNome: null,
      empresaSelecionadaNome: null,
      // RepresentanteArray: [],
      itensMenu: [
        {
          id: "dashboard",
          titulo: "Minha Área",
          subItens: [],
        },
        {
          id: "pasta_produtos-cliente_produtos-estoque",
          titulo: "Consultas",
          subItens: [
            {
                id:"produtos-cliente",
                titulo: "Produtos por Cliente",
                subItens:[]
            },
            {
                id:"produtos-estoque",
                titulo: "Produtos em Estoque",
                subItens: [],
            },
            {
              id:"vendas-por-periodo",
              titulo: "Vendas por Período",
              subItens: [],
            },
            {
              id:"comissoes",
              titulo: "Comissões",
            },
            {
              id:"notas-fiscais",
              titulo: "Notas Fiscais",
              subItens: [],
            },
            {
              id:"titulos",
              titulo: "Títulos",
              subItens: [],
            },
            {
              id:"devolucoes",
              titulo: "Devoluções",
              subItens: [],
            },
          ],
        },
        {
          id: "pasta_formularios_reclamacao-tecnica-comercial_checklist-amostra-lote",
          titulo: "Formulários",
          subItens: [
            {
              id:"reclamacao-tecnica-comercial",
              titulo: "Reclamação Técnica / Comercial",
              subItens: [],
            },
            {
              id:"checklist-amostra-lote",
              titulo: "Checklist de Amostra / Lote",
              subItens: [],
            },
          ]
        },
        {
          id: "pasta_cliente_cliente-em-desenvolvimento_ficha-cadastro_cliente-consulta",
          titulo: "Clientes",
          subItens: [
          {
            id:"cliente-em-desenvolvimento",
            titulo: "Em Desenvolvimento",
            subItens: [],
          },
          {
            id:"ficha-cadastro",
            titulo: "Ficha Cadastral",
            subItens:[],
          },
          {
            id:"cliente-consulta",
            titulo: "Cliente Consulta",
            subItens:[],
          }
          ],
        },
        {
          id: "orcamento_consultar-orcamento_produto-novo-inicio_orcamento-em-digitacao_produto-repeticao-inicio_produto-repeticao-alteracao-inicio_orcamentos-pendentes",
          titulo: "Orçamentos",
          subItens: [
            {
              id:"consultar-orcamento",
              titulo: "Consultar Orçamento",
              subItens:[]
          },
          {
              id:"produto-novo-inicio",
              titulo: "Produto Novo",
              subItens: [],
          },
          {
            id:"orcamento-em-digitacao",
            titulo: "Em Digitação",
          },
          {
            id:"orcamentos-liberados",
            titulo: "Liberados",
          },
          {
            id:"produto-repeticao-inicio",
            titulo: "Produto Repeticao",
            subItens: [],
          },
          {
            id:"produto-repeticao-alteracao-inicio",
            titulo: "Produto Repetição c/ Alteração",
            subItens: [],
          },
          {
            id:"orcamentos-pendentes",
            titulo: "Pendentes de Retorno",
            subItens:[]
          },
          ],
        },

        {
          id: "pasta_gerar-carta-proposta-inicio_carta-proposta-em-digitacao_cartas-proposta-aguardando-aprovacao",
          titulo: "Cartas-Proposta",
          subItens: [
            {
                id:"gerar-carta-proposta-inicio",
                titulo: "Gerar Carta-Proposta",
                subItens:[],
            },
            {
              id: "carta-proposta-em-digitacao",
              titulo: "Em Digitação",
              subItens: [],
            },
            {
              id: "consultar-cartas-proposta",
              titulo: "Consultar Cartas-Proposta",
              subItens: [],
            },
            // {
            //   id: "cartas-proposta-aguardando-aprovacao",
            //   titulo: "Aguardando Aprovação",
            //   subItens: [],
            // }

          ],
        },

        {
          id: "pasta_pedidos",
          titulo: "Pedidos",
          subItens: [
            {
              id:"gerar-novo-pedido-inicio",
              titulo: "Gerar Novo Pedido",
              subItens: [],
            },
            {
              id:"pedido-em-digitacao",
              titulo: "Em Digitação",
              subItens: [],
            },
            {
              id:"pedido-em-fase-digitacao",
              titulo: "Em Fase De Digitação",
              subItens: [],
            },
            {
              id:"andamento-de-pedidos",
              titulo: "Andamento de Pedidos",
              subItens: [],
            },
            {
              id:"pedido-expedido-faturado",
              titulo: "Expedidos / Faturados",
              subItens: [],
            },
            {
              id:"pedido-cancelado-liquidado",
              titulo: "Cancelados",
              subItens: [],
            },
          ],
        },

        {
          id:"gerenciamento_gerenciamento-usuarios-geral_gerenciamento-grupos_gerenciamento-menu_gerenciamento-log_gerenciamento-representante_gerenciamento-usuarios-logados_gerenciamento-acessos_gerenciamento-comissoes_gerenciamento-cidades-tipo-frete_gerenciamento-impostos",
          titulo: "Gerenciamento",
          subItens: [
            {
              id: "gerenciamento-usuarios-geral",
              titulo: "Usuário",
              subItens: []
            },
            {
              rota: "gerenciamento-cidades-tipo-frete",
              titulo: "Cidades",
            },
            {
              id: "gerenciamento-grupos",
              titulo: "Grupos",
              subItens: []
            },
            {
              id: "gerenciamento-acessos",
              titulo: "Acessos",
              subItens: []
            },
            {
              id: "gerenciamento-transportadoras",
              titulo: "Transportadoras",
              subItens: []
            },
            {
              id: "gerenciamento-comissoes",
              titulo: "Comissões",
              subItens: []
            },
            {
              id: "gerenciamento-log",
              titulo: "Log",
              subItens: []
            },
            {
              id: "gerenciamento-parametros",
              titulo: "Parâmetros",
              subItens: []
            },
            // {
            //   id: "gerenciamento-menu",
            //   titulo: "Menu",
            //   subItens: []
            // },
            {
              id: "gerenciamento-representante",
              titulo: "Liberação de Representante",
              subItens: []
            },
            {
              id: "gerenciamento-usuarios-logados",
              titulo: "Usuários Logados",
              subItens: []
            },
            {
              id: "gerenciamento-condicoes-pagamento",
              titulo: "Condições de Pagamento",
              subItens: []
            },
            {
              id: "gerenciamento-impostos",
              titulo: "Impostos",
              subItens: []
            },
          ],
        },
        {
          id: "ajuda",
          titulo: "Ajuda",
          subItens: [],
        },
      ],

      itensGerenc: [
        {
          rota: "gerenciamento-usuarios-geral",
          titulo: "Usuário",
          possuiAcesso: false
        },
        {
          rota: "gerenciamento-cidades-tipo-frete",
          titulo: "Cidades",
          possuiAcesso: false
        },
        {
          rota: "gerenciamento-grupos",
          titulo: "Grupos",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-acessos",
          titulo: "Acessos",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-transportadoras",
          titulo: "Transportadora",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-comissoes",
          titulo: "Comissões",
          possuiAcesso: false

        },
        // {
        //   rota: "gerenciamento-menu",
        //   titulo: "Menu",
        // },
        {
          rota: "gerenciamento-log",
          titulo: "Log",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-parametros",
          titulo: "Parâmetros",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-representante",
          titulo: "Liberação de Representante",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-usuarios-logados",
          titulo: "Usuários Logados",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-condicoes-pagamento",
          titulo: "Condições de Pagamento",
          possuiAcesso: false

        },
        {
          rota: "gerenciamento-impostos",
          titulo: "Impostos",
          possuiAcesso: false

        },
      ],
    };
  },

  computed: {
    representanteEEmpresaSelecionados(){
      let retorno = !(
        Tools.validaVariavelPreenchida(this.$store.state.representanteSelecionadoId)
        && Tools.validaVariavelPreenchida(this.$store.state.empresaSelecionadaId)
        )
      return retorno
    },
    camposPreenchidos(){
      return !(this.empresaSelecionadaId
      && this.representanteSelecionadoId
      )
    },
  },

  mounted () {
    
    console.log(process.env.VUE_APP_WEB_API + 'meuperfil')
    this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'meuperfil',
        headers: {'Authorization': `Bearer ${JWTService.GetToken()}`}

      }).then(res => this.dadosUsuario = res.data.data);
      this.EmpresaArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
      this.empresaSelecionadaId = this.$store.state.empresaSelecionadaId
      this.representanteSelecionadoNome = this.$store.state.representanteSelecionadoNome 
      this.empresaSelecionadaNome = this.$store.state.empresaSelecionadaNome 
      if(this.hasClaim('adm')){
        this.representanteSelecionadoId = this.$store.state.representanteSelecionadoId;
      } else {
        RepresentanteController.GetRepresentanteByUsuarioLogado().requisicao
        .then(res => {
          this.RepresentanteArray = res.data.data
          if(this.RepresentanteArray.length > 0){
            this.representanteSelecionadoId = res.data.data[0].representanteId;
            return;
          }
          if(this.RepresentanteArray.length == 0){
            this.representanteSelecionadoId = this.$store.state.representanteSelecionadoId;
            return;
          }
          this.representanteSelecionadoId = '';
          // if(this.$store.state.representanteSelecionadoId){
          //   this.representanteSelecionadoId = this.$store.state.representanteSelecionadoId;
          //   return;
          // }
        })
      }

    let precisaEscolher = !this.$store.state.empresaSelecionadaId
    if(precisaEscolher){
      this.unidadeRepresentanteMenu = true;
      this.mitt.emit(EVENTS.ligaModalSistema)
    }
    else{
      this.empresaSelecionadaId = this.$store.state.empresaSelecionadaId;
      this.representanteSelecionadoId = this.$store.state.representanteSelecionadoId;
      this.representanteSelecionadoNome = this.$store.state.representanteSelecionadoNome;
      this.empresaSelecionadaNome = this.$store.state.empresaSelecionadaNome;
    }

    this.verificaClaimsGMENU()
  },

  mixins:[AccountLoged],

  methods: {
    enviarCRM(){
      UsuarioController.GetCodigoExternoByUsuarioLogado().requisicao
        .then(res => {
          window.open(process.env.VUE_APP_CRM +`/Account/SSO?codigoExternoUsuario=U-${res.data.data}&appSecret=2e6a856bf7d5e074a68172edcb196551`, '_blank');

        })
        
    },
    verificaClaimsGMENU() {
      this.TokenClaims = this.dataUser.CLAIMS
      let acessosGerenciamento = this.TokenClaims.filter(str => str.startsWith('Gerenciamento-'))
                                                  .map(str => str.replace('Gerenciamento-', ''))
                                                  .map(str => str);
  
      let array = acessosGerenciamento.sort()
      this.itensGerenc.forEach((ELement) => {
        let verificar = array.find((ElementClaims) => ElementClaims == ELement.titulo)
        ELement.possuiAcesso = verificar != null && verificar != undefined
      })
      if(acessosGerenciamento.length > 0) {
        this.TypeGerenciamento = true
      }
    },
    buscarRepresentante(pesquisaDigitada){
      window.clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        RepresentanteController.getRepresentanteByPesquisaEUsuario(pesquisaDigitada).requisicao
        .then(response => {
          this.RepresentanteArray = response.data.data;

        })
      }, 1000);

    },

    fecharMenuSuperior(){
      this.tentouFechar = true;
      if(this.representanteEEmpresaSelecionados){
        this.unidadeRepresentanteMenu = false
        this.empresaSelecionadaId = this.$store.state.empresaSelecionadaId;
        this.representanteSelecionadoId = this.$store.state.representanteSelecionadoId;
        this.RepresentanteArray = this.$store.state.RepresentanteArray;

      }
    },

    redirecionar(rota){
      router.push(`/${rota}`)
    },

    ativo(rota){
      return rota.includes(this.$route.path.replace('/','')) ? 'ativo' : ''
    },

    selecionarPagina() {
      this.menuVisivel = false
    },

    deslogar () {
      JWTService.DestroyToken()
      this.$store.state.empresaSelecionadaId = '';
      this.$store.state.representanteSelecionadoId = '';
      this.$store.state.RepresentanteArray = [];
      this.$store.state.representanteSelecionadoNome = ''
      this.$store.state.empresaSelecionadaNome = ''
      this.$store.commit('salvando');
      router.replace({ name: 'Login' });
    },

    retornaDashboard(){
      router.push("/dashboard")
    },

    ajuda(){
      this.$router.push('/ajuda')
    },

    gerenciamento(){
      this.gerenciamento=true;

    },

    meuperfil(){
      this.$router.push("/meu-perfil")
    },

    abrirpopupsair(){
      this.popupsair=true
    },

    fecharpopupsair(){
      this.popupsair=false
    },

    fecharconfiguracoes(){
      this.configuracoes=true
    },

    salvarUnidadeRepresentante(){
      /*eslint-disable*/
      if(!this.camposPreenchidos){
        this.$store.state.empresaSelecionadaId = this.empresaSelecionadaId;

        this.$store.state.RepresentanteArray = this.RepresentanteArray;

        this.getNomeRepresentanteEmpresa()
        this.$store.state.representanteSelecionadoNome = this.representanteSelecionadoNome
        this.$store.state.empresaSelecionadaNome = this.empresaSelecionadaNome

        if(this.representanteSelecionadoNome == 'ADMINISTRADOR'){
          this.$store.state.representanteSelecionadoId = null  
          }
        else {
          this.$store.state.representanteSelecionadoId = this.representanteSelecionadoId;
        }

        window.localStorage.setItem('Representante', this.representanteSelecionadoId);
        this.$store.commit('salvando');
        this.mitt.emit(EVENTS.trocaEmpresaRepresentante);
        this.mitt.emit(EVENTS.desligaModalSistema);
        this.mitt.emit(EVENTS.cliente.limparDropdown);
        this.unidadeRepresentanteMenu = false
      }

    },

    getNomeRepresentanteEmpresa(){
      let empresa = this.EmpresaArray.find(e => e.id == this.empresaSelecionadaId);
      if(!empresa) this.empresaSelecionadaNome = '';
      else this.empresaSelecionadaNome =  empresa.nome;

      let representante =  this.RepresentanteArray.find(e => e.representanteId == this.representanteSelecionadoId);
      if(!representante) this.representanteSelecionadoNome = '';
      else this.representanteSelecionadoNome = representante.nomeRepresentante.trim();

    },
  },
});
